/**
 * `<DarkPillTooltip>` — slate-900 pill tooltip used for in-field affordance
 * hints (e.g. "Auto-fill address from postal code"). Matches the design's
 * `[data-tip]` style: `#0f172a` bg, white 11px text, arrow above the trigger.
 *
 * Wraps MUI's `<Tooltip>` so callers stay generic; only the styling differs
 * from the default `<Tooltip>` to give in-field affordance hints a stronger
 * visual weight than the surrounding form labels.
 */

import Tooltip, { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const DarkPillTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow placement="top" classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#0f172a',
    color: '#fff',
    fontSize: 11,
    lineHeight: 1.4,
    padding: '6px 10px',
    borderRadius: 6,
    maxWidth: 240,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#0f172a',
  },
}));
